import { GetServerSideProps } from "next";
import React from "react";
import { STORE_VERSION } from "../../assets/interfaces";
import StoreFrontV2, { StoreFrontProps } from "@/components/storefronts-v2";
import StoreFrontV1 from "@/components/storefronts-v1/root";
import { slugServerSideProps } from "@/assets/js/store-server-side-props";
import { NotFoundMain } from "../404";
import StorefrontContext, { VisitRoute } from "@/contexts/storefront";

const StoreFront: React.FC<StoreFrontProps> = (props) => {
  if (!props.data?.store) {
    return <NotFoundMain />;
  }

  return (
    <StorefrontContext.Provider initialState={{ route: VisitRoute.SLUG, store: props.data?.store }}>
      {props.data?.store?.flags?.storefront_version === STORE_VERSION.V1 ? (
        <StoreFrontV1 {...props} />
      ) : (
        <StoreFrontV2 {...props} />
      )}
    </StorefrontContext.Provider>
  );
};

export const getServerSideProps: GetServerSideProps = slugServerSideProps;

export default StoreFront;
